import type { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getHomeByRole } from "../../core/auth/route-access";
import { useAuthSessionContext } from "./auth-session-store";

export type PublicOnlyRouteProps = {
	redirectAuthenticatedTo?: string;
	children?: ReactNode;
};

export function PublicOnlyRoute({
	redirectAuthenticatedTo,
	children,
}: PublicOnlyRouteProps) {
	const { isAuthenticated, role, isLoading } = useAuthSessionContext();

	if (isLoading) return null;

	if (!isAuthenticated) {
		return children ? <>{children}</> : <Outlet />;
	}

	// During login hydration there can be a short state with token set but role unresolved.
	// Avoid redirecting to '/' in that transient state to prevent landing flicker.
	if (!role) {
		return children ? <>{children}</> : <Outlet />;
	}

	const fallback = redirectAuthenticatedTo ?? getHomeByRole(role);
	return <Navigate to={fallback} replace />;
}
